<template>
<div class="modal-card" style="width: auto">
  <header class="modal-card-head">
    <p class="modal-card-title">Tracing</p>
  </header>

  <P5 v-bind:sensorData="sensorData">
  </P5>

  <section class="modal-card-body">
    <DeviceOrientationEvent
      v-on:deviceorientation=onNewSensorData>
    </DeviceOrientationEvent>

    <WebRTC
      key="mobile"
      ref="rtc"
      v-bind:rtcDebug="rtcDebug"
      v-on:rtc_open="onRTCOpen"
      v-on:rtc_close="onRTCClose"
      v-on:rtc_message="onRTCMessage">
    </WebRTC>

  </section>

  <footer class="modal-card-foot">
    <b-button
      size="is-large"
      v-on:click="leaveTrace()">
      Leave
    </b-button>
  </footer>

</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import WebRTC from '@/components/WebRTC'
import DeviceOrientationEvent from '@/components/DeviceOrientationEvent'
import P5 from '@/components/P5'
import LiveTrace from '@/models/LiveTrace'

export default {
  components: {
    WebRTC,
    DeviceOrientationEvent,
    P5
  },
  props: {
    trace: {
      type: LiveTrace,
      required: true
    }
  },
  data () {
    return {
      sensorData: {},
      rtcDebug: true,
      sensorDebug: true
    }
  },
  computed: {
    ...mapState({
      id: state => state.auth.id,
      shortName: state => state.auth.short_name
    }),
    ...mapGetters(['me'])
  },
  methods: {
    joinTrace (peer) {
      // Start RTC call (caller is polite).
      this.$refs.rtc.startCall(
        // Peers must be an array.
        [peer],
        true)
    },
    leaveTrace () {
      this.$refs.rtc.close()
      this.$parent.close()
    },
    // WebRTC callbacks.
    onRTCOpen (peer) {
      console.log('onRTCOpen', peer)
    },
    onRTCClose (peer) {
      console.log('onRTCClose', peer)
      // Remote closed the trace.
      this.$parent.close()
    },
    onRTCMessage (data) {
      // console.log('onRTCMessage', data)

      // FIXME: data or message?!
      if (data.type === 'orientation') {
        // Add data from other peers.
        if (!this.seenPeerBefore(data.from.channel_name)) {
          // Initialise peer's data property.
          this.$set(
            this.sensorData,
            data.from.channel_name,
            {}
          )
        }
        this.$set(
          this.sensorData[data.from.channel_name],
          data.type,
          data.sensorData
        )
      }
    },
    seenPeerBefore (channelName) {
      return Object.prototype.hasOwnProperty.call(
        this.sensorData,
        channelName
      )
    },
    // Sensor callbacks.
    onNewSensorData (message) {
      // Use channel name as key to sensor message to uniquely
      // identify multiple devices logged in by the same user.
      this.$set(
        this.sensorData[this.me.channel_name],
        message.type,
        message.sensorData
      )

      // Add sender information so peer can use this to store the
      // data.
      message.from = this.me

      // Send to peers (singular trace host in this case).
      this.$refs.rtc.sendJson(message)
    }
  },
  mounted () {
    // Initialise this user's sensor data object based on their
    // channel name.
    this.sensorData = { [this.me.channel_name]: {} }

    // Join live trace.
    this.joinTrace({
      // These are all peer details.
      channel_name: this.trace.channel_name,
      short_name: this.trace.short_name,
      user_id: this.trace.user_id
    })
  }
}
</script>
